import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import { getUserConfig } from "../../Services/apiService";
import { NewsFeed, resume } from "../../config/imagesLink";
import AddSkill from "./AddSkill";
// import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
// import Button from "react-bootstrap/Button";
import Connection from "./Connection";
import { Link } from "react-router-dom";
import UpdateProfile from "./UpdateProfile";
import ProfileExperience from "./ProfileExperience";
import ProfileCertification from "./ProfileCertification";
// Migrated from moment/dayjs direct usage to lightweight helpers
import { formatDate, formatIfValid } from "../../utility/date";
import { getVisibleProfileItems } from "../../utility/profileVisibility";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import ProfileAward from "./ProfileAward";
import { Input } from "reactstrap";
import ProfileEducationUpdate from "./ProfileEducationUpdate";
import ProfileExperienceUpdate from "./ProfileExperienceUpdate";
import ProfileCertificateUpdate from "./ProfileCertificateUpdate";
import ProfileAwardUpdate from "./ProfileAwardUpdate";
import AddSkillModal from "./AddSkill";
import UpdateSkills from "./UpdateSkills";
import ProfileNegativeActions from "./ProfileNegativeActions";
import Skills from "./Skills";
import Flatpickr from "react-flatpickr";
import ReactSelect from "react-select";
import Select from "react-select";
// import ProfileAchiementExperience from "./ProfileAchiementExperience";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import LocationOnSharpIcon from "@mui/icons-material/LocationOnSharp";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import ArrowForwardSharpIcon from "@mui/icons-material/ArrowForwardSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import AddExperienceAchivement from "./AddExperienceAchivement";
import EditExperienceAchivement from "./EditExperienceAchivement";
import AddExperienceRole from "./AddExperienceRole";
import EditExperienceRole from "./EditExperienceRole";
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import MyLocationSharpIcon from "@mui/icons-material/MyLocationSharp";
import WcSharpIcon from "@mui/icons-material/WcSharp";
import LanguageSharpIcon from "@mui/icons-material/LanguageSharp";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import SupervisedUserCircleSharpIcon from "@mui/icons-material/SupervisedUserCircleSharp";
import WorkspacePremiumSharpIcon from "@mui/icons-material/WorkspacePremiumSharp";
import MilitaryTechSharpIcon from "@mui/icons-material/MilitaryTechSharp";
import PsychologySharpIcon from "@mui/icons-material/PsychologySharp";
import SyncSharpIcon from "@mui/icons-material/SyncSharp";
import PlaceSharpIcon from "@mui/icons-material/PlaceSharp";
import EndorseModal from "./EndorseModal";
import WarningAmberSharpIcon from "@mui/icons-material/WarningAmberSharp";
import OfferAJobs from "../ManageJob/OfferAJobs";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import PersonAddAlt1SharpIcon from "@mui/icons-material/PersonAddAlt1Sharp";
import ChatBubbleOutlineSharpIcon from "@mui/icons-material/ChatBubbleOutlineSharp";
import { customStyles } from "../../selectStyles";
import ProfileEducation from "./ProfileEducation";
import { Loader } from "react-feather";
import { ShimmerDiv } from "@skeleton";
import { useTranslation } from "react-i18next";
import ModalForGuest from "../ModalForGuest";
import ProfileBasicInfoModal from "./ProfileBasicInfoModal";


const About = ({ uid, userData, getUserProfile, setOpenToModal, isloading,
  connectionCheck,
            setConnectionCheck,
            connectionId={connectionId},
            CheckConnectUser,
            setDisconectCheck,
            disconectCheck,
            isfollowed,
            setIsfollowed,
            checkblock,
            setCheckblock,
 }) => { 
  console.log("userData===>", userData);
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const guestModeData = localStorage.getItem("guestMode");
  const [showAddSkill, setShowAddSkill] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [showCancelRequestModal, setShowCancelRequestModal] = useState(false);
  // const [userSkillId, setUserSkillId] = useState("");
  const [comment, setComment] = useState("");

  const handleOpenAddSkill = () => setShowAddSkill(true);
  const handleCloseAddSkill = () => setShowAddSkill(false);

  const userUid = localStorage.getItem("userUid");
  const sessionId = localStorage.getItem("sessionId");
  //************************User Skill Get Start  ************************//

  const [skillList, setSkillList] = useState([]);
  // console.log('skillList', skillList);
  // const getUserSkill = () => {
  //   axios
  //     .post(`UserSkill/GetUserLinkedSkills?DeviceType=Web&UID=${uid}`)
  //     .then((response) => {
  //       const res = response.data.responseData;
  //       console.log("SKill Response====>",res)
  //       setSkillList(res);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // useEffect(() => {
  //   getUserSkill();
  // }, [userData]);

  //************************User Skill Get End  ************************//

  //************************Remove Skill start  ************************//
  const [show, setShow] = useState(false);
  const [showMoreSkills, setShowMoreSkills] = useState(false);
  const handleRemoveSkillClose = () => {
    setShow(false);
  };
  const [skillId, setSkillId] = useState("");

  const [skillsData, setSkillsData] = useState([]);
  const [showSkills, setShowSkills] = useState(false);

  const handleUpdateSkillClose = () => {
    setShowSkills(false);
  };

  const removeSkills = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      usrSkllId: skillId,
      langKey: language === "en" ? "" : language,
      // skllId: skillId
    };
    try {
      await axios.post(`UserSkill/UnlinkSkill`, responseData).then((res) => {
        setShow(!show);
        // toast.success("Skill Deleted");
        setToastMessage(res.data.message);
        setShowToast(true);
        getUserProfile();
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Remove Skill End  ************************//
  const [showCertificateUpdate, setShowCertificateUpdate] = useState(false);
  const handleUpdateCertificateClose = () => {
    setShowCertificateUpdate(false);
  };
  const [certificateData, setCertificateData] = useState([]);

  const [showEducationUpdate, setShowEducationUpdate] = useState(false);
  const handleUpdateEducationClose = () => {
    setShowEducationUpdate(false);
  };

  //************************Remove Education Start  ************************//

  const [showAwardUpdate, setShowAwardUpdate] = useState(false);
  const [showAwardData, setAwardData] = useState([]);
  const handleUpdateAwardClose = () => {
    setShowAwardUpdate(false);
  };

  //************************Remove Education End  ************************//

  const [ExperienceData, setExperienceData] = useState([]);
  const [ExperienceId, setExperienceId] = useState("");
  const [showExperienceUpdate, setShowExperienceUpdate] = useState(false);
  const handleUpdateExperienceClose = () => {
    setShowExperienceUpdate(false);
    setExperienceData([]);
  };

  //************************Endorse User  ************************//
  const [showEndorseModal, setShowEndorseModal] = useState(false);
  const handleClose = () => {
    setShowEndorseModal(false);
  };
  const EndorseData = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      usrSkllId: skillId,
      feedback: comment,
      langKey: language === "en" ? "" : language,
    };
    // console.log("user feedback data", data);
    if (comment === "") {
      setWarningToastMessage("Please Add Feedback");
      setShowWarningToast(true);
    } else {
      try {
        await axios.post("UserSkill/EndorseSkill", data).then((resData) => {
          // console.log("resData", resData);
          setComment("");
          setShowEndorseModal(false);
          // toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
        });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
  };
  //************************Endorse User  ************************//

  //************************Undo Endorse User  ************************//
  const [showUndoEndorseModal, setShowUndoEndorseModal] = useState(false);
  const handleUndoEndorse = () => {
    setShowUndoEndorseModal(false);
  };
  const UndoEndorseData = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      usrSkllId: skillId,
      feedback: comment,
      langKey: language === "en" ? "" : language,
    };
    // console.log("user feedback data", data);
    if (comment === "") {
      setWarningToastMessage("Please Add Feedback");
      setShowWarningToast(true);
    } else {
      try {
        await axios.post("UserSkill/UndoEndorseSkill", data).then((resData) => {
          // console.log("resData", resData);
          setComment("");
          setShowUndoEndorseModal(false);
          // toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
        });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
  };
  //************************Endorse User  ************************//

  //************************Followed User  ************************//

  const FollowedUser = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post("UserFollow/FollowUser", data).then((resData) => {
        // console.log("Follow=resData", resData); 
        setIsfollowed(true);
        setToastMessage(resData.data.message);
        setShowToast(true);
        getUserProfile();
        // CheckFollowedUser();
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  console.log("isfollowed", isfollowed);
  //************************Followed User  ************************//

  //************************Check Followed User  ************************//
  // const [checkFollowedUser, setCheckFollowedUser] = useState("");
  // // api removed from backend
  // const CheckFollowedUser = async (id) => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     userUID: uid,
  //   };
  //   try {
  //     await axios.post("CheckConnection/CheckFollowing", data).then((resData) => {
  //       // console.log("checkresData", resData.data);
  //       setCheckFollowedUser(resData.data.status);
  //     });
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   CheckFollowedUser();
  // }, []);

  //************************Check Followed User  ************************//

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  //************************ Connect User Start  ************************//

  const ConnectUser = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post("Connection/SendConnectionRequest", data)
        .then((resData) => {
          // console.log("resData", resData.data.message);
          // toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          // CheckFollowedUser();
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************ Connect User  End  ************************//

  //************************Check Connect User Start  ************************//
  // const [disconectCheck, setDisconectCheck] = useState(userData?.profileInfo?.isConnectedByYou);

  // const [connectionCheck, setConnectionCheck] = useState(""); 
  // const [connectionId, setConnectionId] = useState("");
  // // api removed from backend
  // const CheckConnectUser = async (id) => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     userUID: uid,
  //     langKey: language === "en" ? "" : language,
  //   };
  //   try {
  //     await axios.post("Connection/CheckConnection", data).then((resData) => {
  //       console.log("checkFollowedUser", resData.data);
  //       if (resData.data.status === "Warning") {
  //         // setConnectionCheck("Connect");
  //         // } else {
  //         setConnectionCheck(resData.data.responseData.value);
  //         setConnectionId(resData.data.responseData.id);
  //       }
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleConnectionSuccess = (resData, msgType) => {
    if (msgType === "success") {
      setToastMessage(resData?.data?.message);
      setShowToast(true);
      CheckConnectUser();
    }
    if (msgType === "error") {
      setErrorToastMessage(resData.data.message);
      setShowErrorToast(true);
    }
  };
  const handleConnectionRejected = () => {
    setShowCancelRequestModal(true);
  };
  const cancelRequestClose = () => {
    setShowCancelRequestModal(false);
  };
  const CancelRequest = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    try {
      await axios
        .post("Connection/CancelConnectionRequest", data)
        .then((resData) => {
          console.log(resData);
          setShowCancelRequestModal(false);
          setToastMessage(resData.data.message);
          setShowToast(true);
          CheckConnectUser();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
        setShowCancelRequestModal(false);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
        setShowCancelRequestModal(false);
      }
    }
  };

  //************************ Connect User  End  ************************//

  const [educationData, setEducationData] = useState([]);
  const [showUSEREducation, setShowUSEREducation] = useState(false);

  const handleOpenUSEREducation = () => setShowUSEREducation(true);
  const handleCloseUSEREducation = () => setShowUSEREducation(false);

  const [showUserExperience, setShowUserExperience] = useState(false);
  const [showAchievementUserExperience, setshowAchievementUserExperience] =
    useState(false);

  const handleOpenUserExperience = () => setShowUserExperience(true);
  const handleCloseUserExperience = () => setShowUserExperience(false);

  const handleAchievementUserExperience = () =>
    setshowAchievementUserExperience(true);
  const handleAchievementCloseUserExperience = () =>
    setshowAchievementUserExperience(false);

  const [showUserCertification, setShowUserCertification] = useState(false);

  const handleOpenUserCertification = () => setShowUserCertification(true);
  const handleCloseUserCertification = () => setShowUserCertification(false);

  const [showUserAward, setShowUserAward] = useState(false);
  const handleOpenUserAward = () => setShowUserAward(true);
  const handleCloseUserAward = () => setShowUserAward(false);

  const [showToolbar, setShowToolbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowToolbar(true);
      } else {
        setShowToolbar(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [basicInfoModal, setBasicInfoModal] = useState(false);

  //************************ DOB   ************************//
  const [startDate, setStartDate] = useState(null);
  const [dob, setDob] = useState(false);
  const handledob = () => {
    setDob(false);
  };
  const DobUpload = async () => {
    try {
      if (startDate !== null) {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("Language", language === "en" ? "" : language,);
        formData.append(
          "Dob",
          startDate === "" ? "" : formatDate(startDate, "YYYY-MM-DD")
        );
        const res = await axios.post("/UserAccount/SetDob", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        setToastMessage(res.data.message);
        setShowToast(true);
        setDob(false);
        getUserProfile();
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ DOB  End ************************//

  //************************ Gender   ************************//
  const [genderModal, setGenderModal] = useState(false);
  const handleGenderModal = () => {
    setGenderModal(false);
  };
  const [genderValue, setGenderValue] = useState(null);
  const [genderOptionList, setGenderOptionList] = useState([]);
  const getGenderData = () => {
    try {
      axios.get(`/Master/GetGenderDDL?LangKey=${language}`).then((response) => {
        // console.log("gender data", response.data.responseData);
        setGenderOptionList(response.data.responseData);
        // setLoading(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  let genderOptions = genderOptionList.map((val) => {
    return { value: val.gndrId, label: val.name, id: val.gndrId };
  });


  const selectGender = (val) => {
    // console.log("gender", val.value);
    setGenderValue(val.value);
  };



  useEffect(() => {
    getGenderData();
  }, []);

  const GenderUpload = async () => {
    try {
      if (genderValue !== null) {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("GndrId", genderValue);
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post("/UserAccount/SetGender", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setGenderModal(false);
        // userConfig();
        // getUserProfilePer();
        getUserProfile();
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************ Gender End   ************************//
  //************************ About   ************************//
  const [length, setLength] = useState(userData?.profileInfo?.about?.length);
  const [aboutContent, setAboutContent] = useState("");
  const [aboutModal, setAboutModal] = useState(false);
  const handleAboutModal = () => {
    setAboutModal(false);
  };
  const AboutUpload = async () => {
    try {
      if ((aboutContent || "").trim() === "") {
        setWarningToastMessage("About section cannot be empty.");
        setShowWarningToast(true);
      }
      if ((aboutContent || "").trim() !== "") {
        const currentScroll = window.scrollY;
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("AboutContent", aboutContent);
        // formData.append("Dob", startDate === "" ? "" : formatDate(startDate, "YYYY-MM-DD"));
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post("/UserAccount/SetAbout", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setAboutModal(false);
        // userConfig();
        // getUserProfilePer();
        getUserProfile();


        window.scrollTo(0, currentScroll);
        await getUserProfile();

      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ About  End ************************//

  //************************ Website   ************************//
  const [websitecontent, setWebsitecontent] = useState("");
  const [error, setError] = useState("");
  const isValidWebsiteUrl = (value) => {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return false;
    }

    try {
      const normalizedValue = /^https?:\/\//i.test(trimmedValue)
        ? trimmedValue
        : `https://${trimmedValue}`;
      const parsedUrl = new URL(normalizedValue);

      return Boolean(parsedUrl.hostname && parsedUrl.hostname.includes("."));
    } catch (validationError) {
      return false;
    }
  };

  const validateWebsite = (value) => {
    if (value.trim() !== "" && !isValidWebsiteUrl(value)) {
      setError(
        "Please provide a valid website URL."
      );
    } else {
      setError("");
    }

    setWebsitecontent(value);
  };

  const handleSubmit = () => {
    // if (!websitecontent.trim() || error) {
    if (!isValidWebsiteUrl(websitecontent)) {
      // alert("Please provide a valid website URL.");
      setShowWarningToast(true);
      setWarningToastMessage("Please provide a valid website URL.");


      return;
    }
    websiteUpload(); // Call the submit function if valid
  };
  // const isSubmitDisabled = error !== "" || websitecontent.trim() === "";
  const [websiteModal, setWebsiteModal] = useState(false);
  const handlewebsiteModal = () => {
    setWebsiteModal(false);
  };
  const websiteUpload = async () => {
    try {
      if (websitecontent !== "") {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("Language", language === "en" ? "" : language,);
        formData.append("Website", websitecontent.trim());
        const res = await axios.post("/UserAccount/SetWebsite", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setWebsiteModal(false);
        // userConfig();
        // getUserProfilePer();
        getUserProfile();
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Website  End ************************//

  //************************ City   ************************//
   const [countryData, setCountryData] = useState([]);
  const [countryId, setCountryId] = useState("");
  const [countrySearch, setCountrySearch] = useState(null);
  const getCountry = () => {
    axios   
      .get(`Master/GetCountryDDL?search=${countrySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        console.log("countrydata", res);
        
        const data = res.map((item) => ({
          value: item.countyId,
          label: item.countryName,
          code: item.phoneCode,
        }));
        setCountryData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (countrySearch) {
      getCountry();
    }
  }, [countrySearch]);
  
  //********City List Start  ********//
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState("");
  const getCity = () => {
    axios
      .get(
        `Master/GetCitiesDDL?search=${citySearch || ""}&CountryID=${countryId || ""}&LangKey=${language}`
      )
      .then((response) => {
        const res = response.data.responseData;
        console.log("setCityData", res);
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    // Fetch cities when country changes or when user types a city search
    if (countryId || citySearch) {
      getCity();
    } else {
      setCityData([]);
    }
  }, [countryId, citySearch]);

  const selectcity = (val) => {
    setCityId(val.value);
  };
  //********City List End  ********//
  const [languageModal, setlanguageModal] = useState(false);
  const handlelanguageModal = () => {
    setlanguageModal(false);
  };
  // const [languageValue, setlanguageValue] = useState(null);
  // const [languageOptionList, setlanguageOptionList] = useState([]);
  // const getlanguageData = () => {
  //   try {
  //     axios.get(`/Master/GetLanguageDDL`).then((response) => {
  //       // console.log("language data", response.data.responseData);
  //       setlanguageOptionList(response.data.responseData);
  //       // setLoading(false);
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // let languageOptions = languageOptionList.map((val) => {
  //   return { value: val.langId, label: val.name, id: val.langId };
  // });

  // const selectlanguage = (val) => {
  //   // console.log("language", val.value);
  //   setlanguageValue(val.value);
  // };

  // useEffect(() => {
  //   getlanguageData();
  // }, []);

  const languageUpload = async () => {
    try {
      if (cityId !== null) {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("CityID", cityId);
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post("/UserAccount/SetCity", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setlanguageModal(false);
        // userConfig();
        // getUserProfilePer();
        getUserProfile();
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };


  //************************Enable Education  ************************//
  const [status, setStatus] = useState('')

  const EnableEducation = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: Id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .put(`UserData/EnableEducationInfo`, responseData)
        .then((res) => {
          getUserProfile();
          setToastMessage(res.data.message);
          setShowToast(true);
          // setStatus(1)
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Enable Education End  ************************//
  //************************Disable Education  ************************//
  const DisableEducation = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: Id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .put(`UserData/DisableEducationInfo`, responseData)
        .then((res) => {
          setToastMessage(res.data.message);
          setShowToast(true);
          getUserProfile();
          // setStatus(0)
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Disable Education End  ************************//

  //************************Remove Education Start  ************************//

  const [showEducationDelete, setShowEducationDelete] = useState(false);
  const handleRemoveEducationClose = () => {
    setShowEducationDelete(false);
  };


  const [EducationId, setEducationId] = useState("");
  const removeEducation = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: EducationId,
      langKey: language === "en" ? "" : language,
      // skllId: skillId
    };
    try {
      await axios
        .delete(`UserData/DeleteEducationInfo`, { data: responseData })
        .then((res) => {
          setShowEducationDelete(!showEducationDelete);
          // toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);
          getUserProfile();
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Remove Education End  ************************//


  //************************ City End   ************************//

  console.log("userData", userData?.profileInfo?.cityID);

  useEffect(() => {
    const info = userData?.profileInfo;
    setStartDate(info?.dob || null);
    setGenderValue(info?.genderId);
    setWebsitecontent(info?.website);
    setAboutContent(info?.about);
    setCityId(info?.cityID || null);
    setCitySearch(info?.cityName || "");
    setCountryId(info?.countryID || "");
    setCountrySearch(info?.countryName || null);
    if (info?.countryID && info?.countryName) {
      setCountryData([
        {
          value: info.countryID,
          label: info.countryName,
          code: info.phoneCode || "",
        },
      ]);
    }
    if (info?.cityID && info?.cityName) {
      setCityData([
        {
          value: info.cityID,
          label: info.cityName,
        },
      ]);
    }
  }, [userData?.profileInfo]);

  

  // useEffect(() => {
  //   if (websiteModal || aboutModal || languageModal || genderModal || dob) {
  //     document.body.style.overflow = "hidden";
  //     document.documentElement.style.overflow = "hidden";
  //     document.body.classList.add("modal-open"); // When a modal opens
  //   } else {
  //     document.body.style.overflow = "auto";
  //     document.documentElement.style.overflow = "";
  //     document.body.classList.remove("modal-open"); // When a modal closes
  //   }
  // }, [websiteModal, aboutModal, languageModal, genderModal, dob]);
  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };
  //....................Add Experience Achiewement
  const [showExperienceAchivement, setShowExperienceAchivement] =
    useState(false);
  const handleOpenExperienceAchivement = () =>
    setShowExperienceAchivement(true);
  const handleCloseExperienceAchivement = () =>
    setShowExperienceAchivement(false);

  //....................Update Experience Achiewement
  const [experienceAchivementData, setExperienceAchivementData] = useState("");
  const [showEditExperienceAchivement, setShowEditExperienceAchivement] =
    useState(false);
  const handleOpenEditExperienceAchivement = () =>
    setShowEditExperienceAchivement(true);
  const handleCloseEditExperienceAchivement = () =>
    setShowEditExperienceAchivement(false);

  //....................Delete Experience Achiewement
  const [ExperienceAchivement, setExperienceAchivement] = useState("");
  const [ExperienceAchivementId, setExperienceAchivementId] = useState("");
  const [showExperienceAchievementDelete, setShowExperienceAchievementDelete] =
    useState(false);
  const handleExperienceAchievementClose = () => {
    setShowExperienceAchievementDelete(false);
  };
  const handleRemoveExperienceAchivementClose = () => {
    setShowExperienceAchievementDelete(false);
  };
  const DeleteExperienceAchivement = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: ExperienceAchivementId,
      langKey: language === "en" ? "" : language,
      // id: ExperienceId,
      // // skllId: skillId
    };
    try {
      await axios
        .delete(`UserData/DeleteExperienceAcheivement`, { data: responseData })
        .then((res) => {
          setTimeout(() => {
            getUserProfile();
          }, 500);
          handleRemoveExperienceAchivementClose();
          setToastMessage(res.data.message);
          setShowToast(true);
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //....................Add Responsibilities
  const [showExperienceRole, setShowExperienceRole] = useState(false);
  const handleOpenExperienceRole = () => setShowExperienceRole(true);
  const handleCloseExperienceRole = () => setShowExperienceRole(false);

  //....................Update Responsibilities
  const [experienceRoleData, setExperienceRoleData] = useState("");
  const [showEditExperienceRole, setShowEditExperienceRole] = useState(false);
  const handleOpenEditExperienceRole = () => setShowEditExperienceRole(true);
  const handleCloseEditExperienceRole = () => setShowEditExperienceRole(false);

  //....................Delete Responsibilities
  const [ExperienceRole, setExperienceRole] = useState("");
  const [ExperienceRoleId, setExperienceRoleId] = useState("");
  const [showExperienceRoleDelete, setShowExperienceRoleDelete] =
    useState(false);
  const [profileConfig, setProfileConfig] = useState([]);
  const handleExperienceRoleClose = () => {
    setShowExperienceRoleDelete(false);
  };
  const handleRemoveExperienceRoleClose = () => {
    setShowExperienceRoleDelete(false);
  };
  const DeleteExperienceRole = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: ExperienceRoleId,
      langKey: language === "en" ? "" : language,
      // id: ExperienceId,
      // // skllId: skillId
    };
    try {
      await axios
        .delete(`/UserData/DeleteExperienceRole`, { data: responseData })
        .then((res) => {
          setTimeout(() => {
            getUserProfile();
          }, 500);
          handleRemoveExperienceRoleClose();
          setToastMessage(res.data.message);
          setShowToast(true);
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const [showExperienceDelete, setShowExperienceDelete] = useState(false);
  const handleRemoveExperienceClose = () => {
    setShowExperienceDelete(false);
  };

  //************************Enable Experience  ************************// 
  const EnableExperience = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: Id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .put(`UserData/EnableWorkExperienceInfo`, responseData)
        .then((res) => {
          setToastMessage(res.data.message);
          setShowToast(true);
          getUserProfile();
          // setStatus(1)
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Enable Experience End  ************************//
  //************************Disable Experience  ************************//
  const DisableExperience = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: Id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .put(`UserData/DisableWorkExperienceInfo`, responseData)
        .then((res) => {
          setToastMessage(res.data.message);
          setShowToast(true);
          getUserProfile();
          // setStatus(0)
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Disable Experience End  ************************//


  const removeExperience = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: ExperienceId,
      langKey: language === "en" ? "" : language,
      // skllId: skillId
    };
    try {
      await axios
        .delete(`UserData/DeleteWorkExperienceInfo`, { data: responseData })
        .then((res) => {
          setShowExperienceDelete(!showExperienceDelete);
          // toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);
          getUserProfile();
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Enable Certification  ************************// 
  const EnableCertification = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: Id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .put(`UserData/EnableCertificationInfo`, responseData)
        .then((res) => {
          setToastMessage(res.data.message);
          setShowToast(true);
          getUserProfile();
          // setStatus(1)
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Enable Certification End  ************************//
  //************************Disable Certification  ************************//
  const DisableCertification = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: Id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .put(`UserData/DisableCertificationInfo`, responseData)
        .then((res) => {
          setToastMessage(res.data.message);
          setShowToast(true);
          getUserProfile();
          // setStatus(0)
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Disable Certification End  ************************//

  //************************Remove Certificate End  ************************//

  const [showCertificateDelete, setShowCertificateDelete] = useState(false);
  const handleRemoveCertificateClose = () => {
    setShowCertificateDelete(false);
  };

  const [certificateId, setCertificateId] = useState("");
  const removeCertificate = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: certificateId,
      langKey: language === "en" ? "" : language,
      // skllId: skillId
    };
    try {
      await axios
        .delete(`UserData/DeleteCertificationInfo`, { data: responseData })
        .then((res) => {
          setShowCertificateDelete(!showCertificateDelete);
          // toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);
          getUserProfile();
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Remove Certificate End  ************************//


  //************************Enable Award  ************************// 
  const EnableAwards = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: Id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.put(`UserData/EnableAwardInfo`, responseData).then((res) => {
        setToastMessage(res.data.message);
        setShowToast(true);
        getUserProfile();
        // setStatus(1)
      });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Enable Award End  ************************//
  //************************Disable Award  ************************//
  const DisableAwards = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: Id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.put(`UserData/DisableAwardInfo`, responseData).then((res) => {
        setToastMessage(res.data.message);
        setShowToast(true);
        getUserProfile();
        // setStatus(0)
      });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Disable Award End  ************************//

  const [showAwardDelete, setShowAwardDelete] = useState(false);
  const handleRemoveAwardClose = () => {
    setShowAwardDelete(false);
  };
  const [AwardId, setAwardId] = useState("");
  const removeAward = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: AwardId,
      langKey: language === "en" ? "" : language,
      // skllId: skillId
    };
    try {
      await axios
        .delete(`UserData/DeleteAwardInfo`, { data: responseData })
        .then((res) => {
          setShowAwardDelete(!showAwardDelete);
          // toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);
          getUserProfile();
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  // useEffect(() => {
  //   if (
  //     showUndoEndorseModal ||
  //     showEndorseModal ||
  //     // showAwardDelete ||
  //     // showExperienceDelete ||
  //     // showEducationDelete ||
  //     // showCertificateDelete ||
  //     show ||
  //     showExperienceAchievementDelete
  //   ) {
  //     document.body.style.overflow = "hidden";
  //     document.documentElement.style.overflow = "hidden";
  //     document.body.classList.add("modal-open"); // When a modal opens
  //   } else {
  //     document.body.style.overflow = "unset";
  //     document.documentElement.style.overflow = "";
  //     document.body.classList.remove("modal-open"); // When a modal closes
  //   }
  // }, [
  //   showUndoEndorseModal,
  //   showEndorseModal,
  //   // showAwardDelete,
  //   // showExperienceDelete,
  //   // showEducationDelete,
  //   // showCertificateDelete,
  //   show,
  //   showExperienceAchievementDelete,
  // ]);

  const syncEducation = async (id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`/UserData/SyncEducationInfoToResume`, responseData)
        .then((res) => {
          setTimeout(() => {
            getUserProfile();
          }, 500);
          setToastMessage(res.data.message);
          setShowToast(true);
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  const syncExperience = async (id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`/UserData/SyncExperienceInfoToResume`, responseData)
        .then((res) => {
          setTimeout(() => {
            getUserProfile();
          }, 500);
          setToastMessage(res.data.message);
          setShowToast(true);
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  const syncCertificate = async (id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`/UserData/SyncCertificationInfoToResume`, responseData)
        .then((res) => {
          setTimeout(() => {
            getUserProfile();
          }, 500);
          setToastMessage(res.data.message);
          setShowToast(true);
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  const syncAward = async (id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: id,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`/UserData/SyncAwardInfoToResume`, responseData)
        .then((res) => {
          setTimeout(() => {
            getUserProfile();
          }, 500);
          setToastMessage(res.data.message);
          setShowToast(true);
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };


  function checkResumeExperiences(resumeExperiences) {
    const presentCount = resumeExperiences?.filter(
      (exp) => exp.isPresent === true
    ).length;
    if (presentCount >= 2) {
      return (
        <p className="warningText new-warningText mb-1">
         <WarningAmberSharpIcon style={{ fontSize: '16px' }} />  {t("User Profile.Warning")} : {t("User Profile.More than two experiences are marked as present")}
        </p>
      );

    }
  }
  function checkResumeEducation(resumeEducation) {
    const presentCount = resumeEducation?.filter(
      (exp) => exp.isPresent === true
    ).length;
    console.log("resumeEducation", presentCount);
    if (presentCount >= 2) {
       return (
        <p className="warningText new-warningText">
        <WarningAmberSharpIcon style={{ fontSize: '16px' }} />{t("User Profile.Warning")}: {t("User Profile.More than two education are marked as present")}.
        </p>
      );
   }
  }
  console.log("getUserProfile", userData);

  // offerAJobApiCall//
  const [openJobOfferModal, setOpenJobOfferModal] = useState(false);
  const offerAJobApiCall = async () => {
    setOpenJobOfferModal(true);
  };

  // offerAJobApiCall//

  // useEffect(() => {
  //   if (showCancelRequestModal) {
  //     document.body.classList.add("modal-open");
  //   } else {
  //     document.body.classList.remove("modal-open");
  //   }

  //   return () => {
  //     document.body.classList.remove("modal-open"); // Cleanup when modal is closed
  //   };
  // }, [showCancelRequestModal]);

  const userConfig = async () => {
    try {
      const responseData = await getUserConfig();
      setProfileConfig(responseData);
    } catch (error) { 
    }
  };

  useEffect(() => {
    userConfig();
  }, []);

  const isownprofile = userData?.profileInfo?.isOwn === true;

  const [followModal, setFollowModal] = useState(false);
      const closeModalData = () => {
          setFollowModal(false);
      };

  const isViewingOwnProfile =
    userData?.profileInfo?.isOwn === true || uid === userUid;

  const visibleEducation = getVisibleProfileItems(
    userData?.viewEducationInfo,
    isViewingOwnProfile,
  );
  const visibleExperience = getVisibleProfileItems(
    userData?.viewExperienceInfo,
    isViewingOwnProfile,
  );
  const visibleCertification = getVisibleProfileItems(
    userData?.viewCertificationInfo,
    isViewingOwnProfile,
  );
  const visibleAwards = getVisibleProfileItems(
    userData?.viewAwardsInfo,
    isViewingOwnProfile,
  );
  const visibleSkills = getVisibleProfileItems(
    userData?.viewSkillInfo,
    isViewingOwnProfile,
  );

  return (
    <>
      {isloading ?
        <ShimmerDiv height={180} width={"100%"} className="mb-2" />

        : (
          <>
            {userData?.profileInfo?.isOwn === false ? (
              checkblock === true ? (
                <div className="blocked-action-banner mb-3">
                  <p className="warningText d-flex mb-0 align-items-center new-warningText blocked-action-warning">
                    <WarningAmberSharpIcon className="flex-shrink-0" />
                    <span className="blocked-action-warning-text">
                      <span>{t("User Profile.You have blocked this user")}</span>
                      <Link to="/settings/blockedUser" className="link-style">
                        {t("User Profile.Unblock from settings")}
                      </Link>
                    </span>
                  </p>
                </div>
              ) : (
                <>
                  <div className="d-flex mb-3 userprofileactions">
                    {
                      userData?.profileInfo?.isConnectedByYou === true ? (
                        ""
                      ) : (
                        <>
                        <Connection
                          uid={uid}
                          connectionCheck={connectionCheck}
                          setConnectionCheck={setConnectionCheck}
                          connectionId={connectionId}
                          CheckConnectUser={CheckConnectUser}
                          userData={userData}
                          setDisconectCheck={setDisconectCheck}
                          disconectCheck={disconectCheck}
                            />
                        </>
                      )}
                      { 
                      userData?.profileInfo?.isFollowedByYou === true ||
                      isfollowed === true ? (
                        ""
                      ) : (
                        <div className="unFollowBtn me-3">
                          <button type="button" className="wljPrimaryBtn wlj-chip-btn" 
                          onClick={() => {
                              guestModeData === "true"
                                  ? setFollowModal(true)
                                  : FollowedUser();
                          }}>
                            <PersonAddAlt1SharpIcon />
                            {t("Recommendations.Follow")}
                          </button>
                        </div>
                      )}
                    {profileConfig?.hasCompany && profileConfig?.hasCompany !== null ? (
                      <div className="unFollowBtn me-3">
                        <button
                          type="button"
                          className="mainBtn1 wlj-chip-btn"
                          onClick={offerAJobApiCall}
                        >
                          <BusinessCenterOutlinedIcon />
                          {t("Manage Job.Offer Job")}
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                    {guestModeData === "true" ? (
                       <div className="unFollowBtn me-3">
                      <button type="button" className="mainBtn1 wlj-chip-btn" onClick={() => setFollowModal(true)}>
                        <ChatBubbleOutlineSharpIcon />
                        {t("Notifications.Messages")}
                      </button>
                      </div> 
                    ) : (
                      <Link to={`/Message/${userData?.profileInfo?.userUid}`}>
                      <button type="button" className="mainBtn1 wlj-chip-btn">
                        <ChatBubbleOutlineSharpIcon />
                        {t("Notifications.Messages")}
                      </button> 
                    </Link>
                     )
                    }
                    {/* <Link to={`/Message/${userData?.profileInfo?.userUid}`}>
                        <div className="unFollowBtn me-3">
                      <button type="button" className="mainBtn1 ms- me-3">
                        {t("Notifications.Messages")}
                      </button>
                      </div>
                    </Link> */}

                    <ProfileNegativeActions
                      userData={userData}
                      uid={uid}
                      getUserProfile={getUserProfile}
                      connectionCheck={connectionCheck}
                      CheckConnectUser={CheckConnectUser}
                      type="user"
                      setIsfollowed={setIsfollowed}
                      isfollowed={isfollowed}
                      checkblock={checkblock}
                      setCheckblock={setCheckblock}
                      setDisconectCheck={setDisconectCheck}
                      disconectCheck={disconectCheck}
                    />
                  </div>
                </>
              )
            ) : guestModeData === "true" ? (
              ""
            ) : (
              <UpdateProfile
                getUserProfile={getUserProfile}
                profileInfo={userData?.profileInfo}
              />

            )}
          </>
        )
      }

      {/* Basic Info */}
      {userData?.profileInfo?.profileDataNote && (
        <p className="warningText d-flex my-3 new-warningText">
          {" "}
          <WarningAmberSharpIcon style={{ fontSize: "16px" }} />
          {t("modals.Warning")} {userData?.profileInfo?.profileDataNote}
        </p>
      )}
      <div className="UpdateProfile mb-3 p-3 new-UpdateProfile">
        <div className="d-flex justify-content-between align-items-center mb-2 border-custom pb-2">
          <p className="f-16 fw-bold mb-0">{t("User Profile.Profile Basic Info")}</p>
          {userData?.profileInfo?.isOwn && (
            <EditSharpIcon
              className="material-symbols-sharp pointer"
              onClick={() => setBasicInfoModal(true)}
            />
          )}
        </div>
        {!userData?.profileInfo?.dob &&
          !userData?.profileInfo?.cityName &&
          !userData?.profileInfo?.genderName &&
          !userData?.profileInfo?.website &&
          !userData?.profileInfo?.about && (
            <p className="text-center">{t("Newsfeed.No Basic Info Added")} </p>
          )}
        {userData?.profileInfo?.dob && (
          <div className={`analytic-sub mt-2 mb-1 border-custom pb-2`}>
            <div className="d-flex align-items-start justify-content-between">
              <div className="ms-2">
                <div className="d-flex verified align-items-center">
                  <CalendarMonthSharpIcon className="HeadingIcon" />
                  <p className="f-12 ms-1 me-2">{t("User Profile.Date Of Birth")}</p>
                </div>

                <p className="ms-4 f-14 fw-bold ">{formatIfValid(userData?.profileInfo?.dob, "DD MMM YYYY")}</p>
              </div>
              {userData?.profileInfo?.isOwn && (
                <div className="d-flex align-items-center updateActions">
                  <EditSharpIcon
                    className="material-symbols-sharp pointer me-2"
                    onClick={() => {
                      setDob(true);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {userData?.profileInfo?.cityName && (
          <div className={`analytic-sub mt-2 mb-1 border-custom pb-2`}>
            <div className="d-flex align-items-start justify-content-between">
              <div className="ms-2">
                <div className="d-flex  verified align-items-center">
                  <MyLocationSharpIcon className="HeadingIcon" />
                  <p className="f-12 ms-1  me-2">{t("User Profile.City")}</p>
                </div>

                <p className="ms-4 f-14 fw-bold">{userData?.profileInfo?.countryName}, {userData?.profileInfo?.cityName}</p>
              </div>
              {userData?.profileInfo?.isOwn && (
                <div className="d-flex align-items-center updateActions">
                  <EditSharpIcon
                    className="material-symbols-sharp pointer me-2"
                    onClick={() => {
                      const info = userData?.profileInfo;
                      if (info?.countryID && info?.countryName) {
                        setCountryId(info.countryID);
                        setCountrySearch(info.countryName);
                        setCountryData([
                          {
                            value: info.countryID,
                            label: info.countryName,
                            code: info.phoneCode || "",
                          },
                        ]);
                      }
                      if (info?.cityID && info?.cityName) {
                        setCityId(info.cityID);
                        setCitySearch(info.cityName);
                        setCityData([
                          {
                            value: info.cityID,
                            label: info.cityName,
                          },
                        ]);
                      }
                      setlanguageModal(true);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {userData?.profileInfo?.genderName && (
          <div className={`analytic-sub mt-2 mb-1 border-custom pb-2`}>
            <div className="d-flex align-items-start justify-content-between">
              <div className="ms-2">
                <div className="d-flex verified align-items-center">
                  <WcSharpIcon className="HeadingIcon" />
                  <p className="f-12 ms-1 me-2">{t("User Profile.Gender")}</p>
                </div>

                <p className="ms-4 f-14 fw-bold">{userData?.profileInfo?.genderName}</p>
              </div>
              {userData?.profileInfo?.isOwn && (
                <div className="d-flex align-items-center updateActions">
                  <EditSharpIcon
                    className="material-symbols-sharp pointer me-2"
                    onClick={() => {
                      setGenderModal(true);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {userData?.profileInfo?.website && (
          <div className={`analytic-sub mt-2 mb-1 border-custom pb-2`}>
            <div className="d-flex align-items-start justify-content-between">
              <div className="ms-2">
                <div className="d-flex verified align-items-center">
                  <LanguageSharpIcon className="HeadingIcon" />
                  <p className="f-12 ms-1 me-2">{t("User Profile.Website")}</p>
                </div>
                <a
                  className="ms-4 f-14  fw-bold"
                  href={
                    userData?.profileInfo?.website?.startsWith("http://") ||
                      userData?.profileInfo?.website?.startsWith("https://")
                      ? userData?.profileInfo?.website
                      : `http://${userData?.profileInfo?.website}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {userData?.profileInfo?.website}
                </a>
              </div>
              {userData?.profileInfo?.isOwn && (
                <div className="d-flex align-items-center updateActions">
                  <EditSharpIcon
                    className="material-symbols-sharp pointer me-2"
                    onClick={() => {
                      setWebsiteModal(true);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {userData?.profileInfo?.about && (
          <div className={`analytic-sub mt-2 mb-1 pb-2`}>
            <div className="d-flex align-items-start justify-content-between">
              <div className="ms-2">
                <div className="d-flex align-items-center verified">
                  <InfoOutlinedIcon className="HeadingIcon" />
                  <p className="f-14 ms-1  fw-bold me-2">{t("User Profile.About")}</p>
                </div>

                <p className="ms-1 f-12 postContentDiv">{userData?.profileInfo?.about}</p>
              </div>
              {userData?.profileInfo?.isOwn && (
                <div className="d-flex align-items-center updateActions">
                  <EditSharpIcon
                    className="material-symbols-sharp pointer me-2"
                    onClick={() => {
                      setAboutModal(true);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}

      </div>
      {/* Education */}

      <div className="UpdateProfile mb-3 p-3 new-UpdateProfile">
        {checkResumeEducation(userData?.viewEducationInfo)}

        <div className="d-flex justify-content-between mb-2 border-custom pb-2">
          <div className="d-flex align-items-center">
            <SchoolOutlinedIcon className="HeadingIcon" />
            <p className="f-16 fw-bold ms-1">{t("User Profile.Education")}</p>
          </div>
          {userData?.profileInfo?.isOwn ? (
            <div>
              <div>
                <AddSharpIcon
                  className="material-symbols-sharp pointer"
                  onClick={handleOpenUSEREducation}
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        {!visibleEducation?.length && (
          <p className="text-center">{t("User Profile.No Education Added")}</p>
        )}

        {visibleEducation?.map((item, index) => {
            const isLastItem = index === visibleEducation.length - 1;

            return (
              <>
                {item?.note && (
                  <p className="warningText d-flex new-warningText">
                    {" "}
                    <WarningAmberSharpIcon style={{ fontSize: "16px" }} />
                    {t("modals.Warning")} {item?.note}
                  </p>
                )}
                <div
                  className={`analytic-sub mt-1 mb-0 ${isLastItem ? "" : "border-custom"
                    } pb-2 ${item?.status === 0 ? "disableText" : ""}`}
                  key={index}
                >
                  <div className="d-flex align-items-start justify-content-between">
                    <div className="ms-2">
                      <div className="d-flex verified">
                        <p className="f-16 fw-bold me-1">{index + 1}.</p>
                        <p className="f-16  fw-bold me-2">
                          {item.institutionName && (
                            <>
                              {item.institutionName}
                              {item?.isOrgVrfd === true ? (
                                <img
                                  src={resume.verified}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              ) : item?.isOrgRgd === true ? (
                                <img
                                  src={resume.register}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              ) : (
                                <img
                                  src={resume.unregister}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              )}
                              {item?.isInstitutionDelete && (
                                <img
                                  src={resume.deleted}
                                  width={15}
                                  height={15}
                                />
                              )}
                            </>
                          )}
                          {item.isPresent === true
                            ?
                            <>
                              <span class="badge badge-subtle badge-info ms-2">{t("User Profile.Present")}</span>
                            </>
                            : ''}
                        </p>
                      </div>
                      <div className="ms-3">
                        <div className="d-flex">
                          {item.field && (
                            <p className="me-1 f-14 fw-bold">
                              {t("User Profile.Field")}: {item.field}
                            </p>
                          )}
                          {item.field && <div className="dot"></div>}
                          {item.degree && (
                            <p className="ms-2 f-14 fw-bold">{item.degree}</p>
                          )}
                        </div>
                        {item.activities && (
                          <p className="f-12">{t("User Profile.Activity")}: {item.activities}</p>
                        )}
                        {item.grade && (
                          <p className="f-12">{t("User Profile.Grade")}: {item.grade}</p>
                        )}
                        {item.description && (
                          <p className="f-12 fst-italic">{item.description}</p>
                        )}
                        <div className="d-flex align-items-center">
                          {item.cityName && (
                            <>
                              <PlaceSharpIcon className="material-symbols-sharp locationIcon" />
                              <p className="ms-1 me-1 f-12">{item.cityName}</p>
                              <div className="dot"></div>
                              <p className="ms-2 f-12">
                                ({formatIfValid(item.startYear, "DD MMM YYYY")} -{" "}
                                {item.isPresent === true
                                  ? "Present"
                                  : formatIfValid(item.endYear, "DD MMM YYYY")}
                                )
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {userData?.profileInfo?.isOwn && (
                      <div>
                        <div className="d-flex align-items-center updateActions">
                          {item?.isSyncedWithResume && (
                            <img src={resume.synced} width={15} height={15} />
                          )}
                          <div className="text-end">
                            {userData?.userConfig?.hasDob &&
                              userData?.userConfig?.hasGender &&
                              userData?.userConfig?.hasCity &&
                              userData?.userConfig?.hasCcv === true &&
                              item?.isSyncedWithResume === false && (
                                <button
                                  className="wljSecondaryBtn me-2 syncBtn"
                                  style={{ height: "20px" }}
                                  onClick={() =>
                                    syncEducation(item.userEductnId)
                                  }
                                >
                                  <SyncSharpIcon style={{ fontSize: "14px" }} />{" "}
                                  {t("User Profile.Sync")}
                                </button>
                              )}
                          </div>
                          <div className="form-switch form-check-primary ms-2">
                            <Input
                              type="switch"
                              defaultChecked={item?.status === 1 || status === 1}
                              name="icon-primary"
                              onClick={() => {
                                if (item?.status === 1 || status === 1) {
                                  DisableEducation(item.userEductnId);
                                } else {
                                  EnableEducation(item.userEductnId);
                                }
                              }}
                              className=""
                            />
                          </div>
                          <EditSharpIcon
                            className="material-symbols-sharp pointer me-2 ms-2"
                            onClick={() => {
                              setShowEducationUpdate(!showEducationUpdate);
                              setEducationData(item);
                            }}
                          />
                          <DeleteOutlineSharpIcon
                            className="material-symbols-sharp pointer delete-icon"
                            onClick={() => {
                              setShowEducationDelete(!showEducationDelete);
                              setEducationId(item.userEductnId);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            );
          })}
      </div>

      {/* Experience */}

      <div className="UpdateProfile mb-3 p-3 new-UpdateProfile">
        {checkResumeExperiences(userData?.viewExperienceInfo)}
        <div className="d-flex justify-content-between mb-2 border-custom pb-2">
          <div className="d-flex align-items-center">
            <BusinessCenterOutlinedIcon className="HeadingIcon" />
            <p className="f-16 fw-bold ms-1">{t("User Profile.Experience")}</p>
          </div>
          {userData?.profileInfo?.isOwn && (
            <div>
              <AddSharpIcon
                className="material-symbols-sharp pointer"
                onClick={handleOpenUserExperience}
              />
            </div>
          )}
        </div>
        {!visibleExperience?.length && (
          <p className="text-center">{t("User Profile.No Experience Added")}</p>
        )}
        {/* <div className='analytics d-flex justify-content-between mt-3'> */}
        {/* viewExperienceInfo */}
        {visibleExperience?.map((item, index) => {
            const isLastItem = index === visibleExperience.length - 1;
            const achievements = (item.viewExperienceAchivements || []).filter(
              (achievement) => !achievement.isDeleted
            );
            const responsibilities = (item.viewExperienceRoles || []).filter(
              (role) => !role.isDeleted
            );
            return (
              <>
                {item?.note && (
                  <p className="warningText d-flex new-warningText">
                    {" "}
                    <WarningAmberSharpIcon style={{ fontSize: "16px" }} />
                    {t("modals.Warning")} {item?.note}
                  </p>
                )}
                <div
                  className={`analytic-sub mt-1 mb-0 ${isLastItem ? "" : "border-custom"
                    } pb-2 ${item?.status === 0 ? "disableText" : ""}`}
                >
                  <div className="d-flex align-items-start justify-content-between">
                    <div className="ms-2">
                      <div className="d-flex verified">
                        <p className="f-16 fw-bold me-1">{index + 1}.</p>
                        <p className="f-16 fw-bold me-2">
                          {item.jobTitle && (
                            <>
                              {item.jobTitle}
                              {item?.isOrgVrfd === true ? (
                                <img
                                  src={resume.verified}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              ) : item?.isOrgRgd === true ? (
                                <img
                                  src={resume.register}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              ) : (
                                <img
                                  src={resume.unregister}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              )}
                              {item?.isInstitutionDelete && (
                                <img
                                  src={resume.deleted}
                                  width={15}
                                  height={15}
                                />
                              )}
                            </>
                          )}
                          {item.isPresent === true
                            ?
                            <>

                              <span class="badge badge-subtle badge-info ms-2">{t("User Profile.Present")}</span>
                            </>
                            : ''}

                        </p>
                      </div>
                      <div className="ms-3">
                        {item.companyName && (
                          <p className="me-1 f-14 fw-bold">
                            {item.companyName}
                          </p>
                        )}
                        <div className="d-flex align-items-center">
                          {item.jobTypeName && (
                            <p className="me-2 f-12">{item.jobTypeName}</p>
                          )}
                          {item.cityName && (
                            <>
                              <PlaceSharpIcon className="material-symbols-sharp locationIcon ms-3" />
                              <p className="ms-1 me-1 f-12">{item.cityName}</p>
                              <div className="dot"></div>
                              <p className="ms-2 f-12">
                                ({formatIfValid(item.startDate, "DD MMM YYYY")} -{" "}
                                {item.isPresent === true
                                  ? `${t("User Profile.Present")}`
                                  : formatIfValid(item.endDate, "DD MMM YYYY")}
                                )
                              </p>
                            </>
                          )}
                        </div>
                        <div className="d-flex align-items-center">
                          {item.positionHeadline && (
                            <>
                              {" "}
                              <p className="f-12 me-2">
                                {item.positionHeadline}
                              </p>
                            </>
                          )}
                          {item.workLevelTypeName && item.positionHeadline && (
                            <div className="dot me-2"></div>
                          )}
                          {item.workLevelTypeName && (
                            <>
                              {" "}
                              <p className="f-12 me-2">
                                {item.workLevelTypeName}
                              </p>
                            </>
                          )}
                          {item.workLevelTypeName &&
                            item.workLocationTypeName && (
                              <div className="dot"></div>
                            )}
                          {item.workLocationTypeName && (
                            <>
                              {" "}
                              <p className="f-12 m-2">
                                {item.workLocationTypeName}
                              </p>
                            </>
                          )}
                        </div>
                        {item.description && (
                          <p className="f-12 fst-italic">{item.description}</p>
                        )}
                      </div>
                    </div>
                    {userData?.profileInfo?.isOwn && (
                      <div>
                        <div className="d-flex align-items-center updateActions">
                          {item?.isSyncedWithResume && (
                            <img src={resume.synced} width={15} height={15} />
                          )}
                          <div className="text-end">
                            {userData?.userConfig?.hasDob &&
                              userData?.userConfig?.hasGender &&
                              userData?.userConfig?.hasCity &&
                              userData?.userConfig?.hasCcv === true &&
                              item?.isSyncedWithResume === false && (
                                <button
                                  className="wljSecondaryBtn me-2 syncBtn"
                                  style={{ height: "20px" }}
                                  onClick={() => syncExperience(item.userExpId)}
                                >
                                  <SyncSharpIcon style={{ fontSize: "14px" }} />{" "}
                                  {t("User Profile.Sync")}
                                </button>
                              )}
                          </div>

                          <div className="form-switch form-check-primary ms-2">
                            <Input
                              type="switch"
                              defaultChecked={item?.status === 1 || status === 1}
                              name="icon-primary"
                              onClick={() => {
                                if (item?.status === 1 || status === 1) {
                                  DisableExperience(item.userExpId);
                                } else {
                                  EnableExperience(item.userExpId);
                                }
                              }}
                              className=""
                            />
                          </div>
                          <EditSharpIcon
                            className="material-symbols-sharp pointer me-2 ms-2"
                            onClick={() => {
                              setShowExperienceUpdate(!showEducationUpdate);
                              setExperienceData(item);
                            }}
                          />
                          <DeleteOutlineSharpIcon
                            className="material-symbols-sharp pointer delete-icon"
                            onClick={() => {
                              setShowExperienceDelete(!showExperienceDelete);
                              setExperienceId(item.userExpId);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mt-3 ARCard">
                    <div className="ARCard-header">
                      <div className="ARCard-title">
                        <span className="ARCard-icon ARCard-icon--achievement">
                          <EmojiEventsOutlinedIcon />
                        </span>
                        <h6 className="ARCard-heading">
                          {t("User Profile.Experience Achievement")}
                        </h6>
                        {achievements.length > 0 && (
                          <span className="ARCard-count">{achievements.length}</span>
                        )}
                      </div>
                      {userData?.profileInfo?.isOwn && (
                        <button
                          type="button"
                          className="ARCard-add"
                          onClick={() => {
                            handleOpenExperienceAchivement();
                            setExperienceData(item);
                          }}
                          aria-label={t("modals.Add Experience Achievement")}
                        >
                          <AddSharpIcon />
                        </button>
                      )}
                    </div>
                    <div className="ARCard-body">
                      {achievements.length === 0 ? (
                        <p className="ARCard-empty">
                          {t("User Profile.No Achievement Added")}
                        </p>
                      ) : (
                        achievements.map((roleItem, achIndex) => {
                          const achievementDate = formatIfValid(
                            roleItem.achivementDate,
                            "DD MMM YYYY"
                          );
                          return (
                            <div
                              className="ARCard-item"
                              key={roleItem.expAchvmntId || achIndex}
                            >
                              <div className="ARCard-item-main">
                                <p className="ARCard-item-text">
                                  {roleItem.achievement}
                                </p>
                                {achievementDate && (
                                  <span className="ARCard-item-date">
                                    <CalendarMonthSharpIcon />
                                    {achievementDate}
                                  </span>
                                )}
                              </div>
                              {userData?.profileInfo?.isOwn && (
                                <div className="ARCard-item-actions">
                                  <EditSharpIcon
                                    className="ARCard-action pointer"
                                    onClick={() => {
                                      handleOpenEditExperienceAchivement();
                                      setExperienceAchivementData(roleItem);
                                      setExperienceData(item);
                                    }}
                                  />
                                  <DeleteOutlineSharpIcon
                                    className="ARCard-action ARCard-action--delete pointer"
                                    onClick={() => {
                                      setShowExperienceAchievementDelete(
                                        !showExperienceAchievementDelete
                                      );
                                      setExperienceId(item.userExpId);
                                      setExperienceAchivementId(
                                        roleItem.expAchvmntId
                                      );
                                      setExperienceAchivement(
                                        roleItem.achievement
                                      );
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                  <div className="mt-3 ARCard">
                    <div className="ARCard-header">
                      <div className="ARCard-title">
                        <span className="ARCard-icon ARCard-icon--role">
                          <SupervisedUserCircleSharpIcon />
                        </span>
                        <h6 className="ARCard-heading">
                          {t("User Profile.Responsibilities")}
                        </h6>
                        {responsibilities.length > 0 && (
                          <span className="ARCard-count">
                            {responsibilities.length}
                          </span>
                        )}
                      </div>
                      {userData?.profileInfo?.isOwn && (
                        <button
                          type="button"
                          className="ARCard-add"
                          onClick={() => {
                            handleOpenExperienceRole();
                            setExperienceData(item);
                          }}
                          aria-label={t("modals.Add Responsibilities")}
                        >
                          <AddSharpIcon />
                        </button>
                      )}
                    </div>
                    <div className="ARCard-body">
                      {responsibilities.length === 0 ? (
                        <p className="ARCard-empty">
                          {t("User Profile.No Responsibilities Added")}
                        </p>
                      ) : (
                        responsibilities.map((roleItem, roleIndex) => (
                          <div
                            className="ARCard-item"
                            key={roleItem.expRlId || roleIndex}
                          >
                            <div className="ARCard-item-main">
                              <p className="ARCard-item-text">{roleItem.role}</p>
                            </div>
                            {userData?.profileInfo?.isOwn && (
                              <div className="ARCard-item-actions">
                                <EditSharpIcon
                                  className="ARCard-action pointer"
                                  onClick={() => {
                                    handleOpenEditExperienceRole();
                                    setExperienceRoleData(roleItem);
                                    setExperienceData(item);
                                  }}
                                />
                                <DeleteOutlineSharpIcon
                                  className="ARCard-action ARCard-action--delete pointer"
                                  onClick={() => {
                                    setShowExperienceRoleDelete(
                                      !showExperienceRoleDelete
                                    );
                                    setExperienceId(item.userExpId);
                                    setExperienceRoleId(roleItem.expRlId);
                                    setExperienceRole(roleItem.role);
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </>
            );
          })}
      </div>

      {/* Certificate */}

      <div className="UpdateProfile mb-3 p-3 new-UpdateProfile">
        <div className="d-flex justify-content-between mb-2 border-custom pb-2">
          <div className="d-flex align-items-center">
            <WorkspacePremiumSharpIcon className="HeadingIcon" />
            <p className="f-16 fw-bold ms-1">{t("User Profile.Certification")}</p>
          </div>
          {userData?.profileInfo?.isOwn && (
            <div>
              <AddSharpIcon
                className="material-symbols-sharp pointer"
                onClick={handleOpenUserCertification}
              />
            </div>
          )}
        </div>
        {!visibleCertification?.length && (
          <p className="text-center">{t("User Profile.No Certification Added")}</p>
        )}

        {/* <div className='analytics d-flex justify-content-between mt-3'> */}
        {visibleCertification?.map((item, index) => {
            const isLastItem = index === visibleCertification.length - 1;
            return (
              <>
                {item?.note && (
                  <p className="warningText d-flex new-warningText">
                    {" "}
                    <WarningAmberSharpIcon style={{ fontSize: "16px" }} />
                    {t("modals.Warning")} {item?.note}
                  </p>
                )}
                <div
                  className={`analytic-sub mt-1 mb-0 ${isLastItem ? "" : "border-custom"
                    } pb-2 ${item?.status === 0 ? "disableText" : ""}`}
                >
                  <div className="d-flex align-items-start justify-content-between">
                    {/* <img src={NewsFeed.companyLogo} alt="" width={40} height={40} /> */}
                    <div className="ms-2">
                      <div className="d-flex verified">
                        <p className="f-16 fw-bold me-1">{index + 1}.</p>
                        <p className="f-16 fw-bold me-2">
                          {item.name && (
                            <>
                              {item.name}
                              {item?.isOrgVrfd === true ? (
                                <img
                                  src={resume.verified}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              ) : item?.isOrgRgd === true ? (
                                <img
                                  src={resume.register}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              ) : (
                                <img
                                  src={resume.unregister}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              )}
                              {item?.isInstitutionDelete && (
                                <img
                                  src={resume.deleted}
                                  width={15}
                                  height={15}
                                />
                              )}
                            </>
                          )}
                        </p>
                      </div>
                      <div className="ms-3">
                        {item.orgName && (
                          <p className="me-1 f-14 fw-bold">{item.orgName}</p>
                        )}
                        <div className="d-flex align-items-center">
                          {item.recognition && (
                            <p className="me-1 f-12">{item.recognition}</p>
                          )}
                          {item.credentialId && (
                            <>
                              <div className="dot"></div>
                              <p className="ms-2 f-12">
                                {t("User Profile.ID")}: {item.credentialId}
                              </p>
                            </>
                          )}
                        </div>
                        <div className="d-flex align-items-center">
                          {item.cityName && (
                            <>
                              <PlaceSharpIcon className="material-symbols-sharp locationIcon ms-3" />
                              <p className="ms-1 me-1 f-12">{item.cityName}</p>
                              <div className="dot"></div>
                              <p className="ms-2 f-12">
                                ({formatIfValid(item.issueDate, "DD MMM YYYY")} -{" "}
                                {item.expirationDate === null ? `${t("User Profile.Present")} )` : (
                                  <>
                                    {formatIfValid(item.expirationDate, "DD MMM YYYY")})
                                  </>
                                )}
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {userData?.profileInfo?.isOwn && (
                      <div>
                        <div className="d-flex align-items-center updateActions">
                          {item?.isSyncedWithResume && (
                            <img src={resume.synced} width={15} height={15} />
                          )}
                          <div className="text-end">
                            {userData?.userConfig?.hasDob &&
                              userData?.userConfig?.hasGender &&
                              userData?.userConfig?.hasCity &&
                              userData?.userConfig?.hasCcv === true &&
                              item?.isSyncedWithResume === false && (
                                <button
                                  className="wljSecondaryBtn me-2 syncBtn"
                                  style={{ height: "20px" }}
                                  onClick={() => syncCertificate(item.userCrtfctnId)}
                                >
                                  <SyncSharpIcon style={{ fontSize: "14px" }} />{" "}
                                  {t("User Profile.Sync")}
                                </button>
                              )}
                          </div>

                          <div className="form-switch form-check-primary ms-2">
                            <Input
                              type="switch"
                              defaultChecked={item?.status === 1 || status === 1}
                              name="icon-primary"
                              onClick={() => {
                                if (item?.status === 1 || status === 1) {
                                  DisableCertification(item.userCrtfctnId);
                                } else {
                                  EnableCertification(item.userCrtfctnId);
                                }
                              }}
                              className=""
                            />
                          </div>
                          <EditSharpIcon
                            className="material-symbols-sharp pointer me-2 ms-2"
                            onClick={() => {
                              setShowCertificateUpdate(!showCertificateUpdate);
                              setCertificateData(item);
                            }}
                          />
                          <DeleteOutlineSharpIcon
                            className="material-symbols-sharp pointer delete-icon"
                            onClick={() => {
                              setShowCertificateDelete(!showCertificateDelete);
                              setCertificateId(item.userCrtfctnId);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            );
          })}
      </div>

      {/* Award */}

      <div className="UpdateProfile mb-3 p-3 new-UpdateProfile">
        <div className="d-flex justify-content-between mb-2 border-custom pb-2">
          <div className="d-flex align-items-center">
            <MilitaryTechSharpIcon className="HeadingIcon" />
            <p className="f-16 fw-bold ms-1">{t("User Profile.Awards")}</p>
          </div>
          {userData?.profileInfo?.isOwn && (
            <div>
              <AddSharpIcon
                className="material-symbols-sharp pointer"
                onClick={handleOpenUserAward}
              />
            </div>
          )}
        </div>

        {!visibleAwards?.length && (
          <p className="text-center">{t("User Profile.No Award Added")}</p>
        )}
        {visibleAwards?.map((item, index) => {
            const isLastItem = index === visibleAwards.length - 1;
            return (
              <>
                {item?.note && (
                  <p className="warningText d-flex new-warningText">
                    {" "}
                    <WarningAmberSharpIcon style={{ fontSize: "16px" }} />
                    {t("modals.Warning")} {item?.note}
                  </p>
                )}
                <div
                  className={`analytic-sub mt-1 mb-0 ${isLastItem ? "" : "border-custom"
                    } pb-2 ${item?.status === 0 ? "disableText" : ""}`}
                >
                  <div className="d-flex align-items-start justify-content-between">
                    {/* <img src={NewsFeed.companyLogo} alt="" width={40} height={40} /> */}
                    <div className="ms-2">
                      <div className="d-flex verified">
                        <p className="f-16 fw-bold me-1">{index + 1}.</p>
                        <p className="f-16 fw-bold me-2">
                          {item.name && (
                            <>
                              {item.name}
                              {item?.isOrgVrfd === true ? (
                                <img
                                  src={resume.verified}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              ) : item?.isOrgRgd === true ? (
                                <img
                                  src={resume.register}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              ) : (
                                <img
                                  src={resume.unregister}
                                  width={18}
                                  height={18}
                                  className="ms-1"
                                />
                              )}
                              {item?.isInstitutionDelete && (
                                <img
                                  src={resume.deleted}
                                  width={15}
                                  height={15}
                                />
                              )}
                            </>
                          )}
                        </p>
                      </div>
                      <div className="ms-3">
                        {item.orgName && (
                          <p className="me-1 f-14 fw-bold">{item.orgName}</p>
                        )}
                        <div className="d-flex align-items-center">
                          {item.recognition && (
                            <p className=" me-1 f-12">{item.recognition}</p>
                          )}
                          {item.description && (
                            <>
                              <div className="dot"></div>
                              <p className="ms-2 f-12 fst-italic">{item.description}</p>
                            </>
                          )}
                        </div>
                        <div className="d-flex align-items-center">
                          {item.cityName && (
                            <>
                              <PlaceSharpIcon className="material-symbols-sharp locationIcon ms-3" />
                              <p className="ms-1 me-1 f-12">{item.cityName}</p>
                              <div className="dot"></div>
                              <p className="ms-2 f-12">
                                ({formatIfValid(item.issueDate, "DD MMM YYYY")} -{" "}
                                {formatIfValid(item.expirationDate, "DD MMM YYYY")})
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {userData?.profileInfo?.isOwn && (
                      <div>
                        <div className="d-flex align-items-center updateActions">
                          {item?.isSyncedWithResume && (
                            <img src={resume.synced} width={15} height={15} />
                          )}
                          <div className="text-end">
                            {
                            userData?.userConfig?.hasDob &&
                              userData?.userConfig?.hasGender &&
                              userData?.userConfig?.hasCity &&
                              userData?.userConfig?.hasCcv === true &&
                              item?.isSyncedWithResume === false && (
                                <button
                                  className="wljSecondaryBtn me-2 syncBtn"
                                  style={{ height: "20px" }}
                                  onClick={() => syncAward(item.userAwardId)}
                                >
                                  <SyncSharpIcon style={{ fontSize: "14px" }} />{" "}
                                  {t("User Profile.Sync")}
                                </button>
                              )}
                          </div>

                          <div className="form-switch form-check-primary ms-2">
                            <Input
                              type="switch"
                              defaultChecked={item?.status === 1 || status === 1}
                              name="icon-primary"
                              onClick={() => {
                                if (item?.status === 1 || status === 1) {
                                  DisableAwards(item.userAwardId);
                                } else {
                                  EnableAwards(item.userAwardId);
                                }
                              }}
                              className=""
                            />
                          </div>
                          <EditSharpIcon
                            className="material-symbols-sharp pointer me-2 ms-2"
                            onClick={() => {
                              setShowAwardUpdate(!showAwardUpdate);
                              setAwardData(item);
                            }}
                          />
                          <DeleteOutlineSharpIcon
                            className="material-symbols-sharp pointer delete-icon"
                            onClick={() => {
                              setShowAwardDelete(!showAwardDelete);
                              setAwardId(item.userAwardId);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            );
          })}
      </div>

      {/* Skills */}

      {guestModeData === "true" ? (
        ""
      ) : (
        <div className="UpdateProfile mb-3 p-3 new-UpdateProfile">
          <div className="d-flex justify-content-between mb-2 border-custom pb-2">
            <div className="d-flex align-items-center">
              <PsychologySharpIcon className="HeadingIcon" />
              <p className="f-16 fw-bold ms-1">{t("User Profile.Skills")}</p>
            </div>
            <div>
              {userData?.profileInfo?.isOwn ? (
                <AddSharpIcon
                  className="material-symbols-sharp pointer f-24 "
                  onClick={handleOpenAddSkill}
                />
              ) : (
                ""
              )}
            </div>
          </div>

          {!visibleSkills?.length && (
            <p className="text-center">{t("User Profile.No Skill Added")}</p>
          )}

          {visibleSkills?.length > 0 && (
            <>
              {visibleSkills.slice(0, 2).map((item, index, arr) => {
                const isLastItem = index === arr.length - 1;
                return (
                  <div
                    className={`analytic-sub mt-1 mb-0 ${isLastItem ? "" : "border-custom"
                      } pb-2 ${item?.status === 0 ? "disableText" : ""}`}
                    key={index}
                  >
                    <div className="d-flex align-items-start justify-content-between">
                      <div>
                        <div className="d-flex align-items-center verified">
                          <p className="f-16 fw-bold me-1">{index + 1}.</p>
                          <p className="f-16 pb-0 fw-bold me-2">
                            {item.skillName}
                          </p>
                        </div>
                        {item.firmIndustryTypeName && (
                          <p className="ms-1 f-12">{item.firmIndustryTypeName}</p>
                        )}
                      </div>
                      {userData?.profileInfo?.isOwn && (
                        <div className="d-flex align-items-center updateActions">
                          {item?.isSyncedWithResume && (
                            <img
                              src={resume.synced}
                              width={15}
                              className="me-2"
                            />
                          )}

                          <EditSharpIcon
                            className="material-symbols-sharp pointer me-2 ms-2"
                            onClick={() => {
                              setShowSkills(!showSkills);
                              setSkillsData(item);
                            }}
                          />
                          <DeleteOutlineSharpIcon
                            className="material-symbols-sharp pointer delete-icon"
                            onClick={() => {
                              setShow(!show);
                              setSkillId(item.usrSkllId);
                            }}
                          />
                        </div>
                      )}
                    </div>
                    {(item.endorsedCount > 0 || uid !== userUid) && (
                    <div className="d-flex align-items-center justify-content-between mt-1">
                    {
                      item.endorsedCount > 0 && (
                        <p className="ms-1 f-12 pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            handleShow();
                            setSkillId(item.usrSkllId);
                            // toggleTooltip();
                          }}
                          // className="createModal f-14 ms-2"
                        >
                          {item.endorsedCount} {t("User Profile.endorsement")}
                        </p>
                      )
                    }
                    {uid !== userUid && (
                      <div className="endorseBtn ">
                        {item.isEndorsedByYou === true ? (
                          <button
                            className="button followStyle"
                            onClick={() => {
                              setShowUndoEndorseModal(!showUndoEndorseModal);
                              setSkillId(item.usrSkllId);
                            }}
                            style={{ width: "100px" }}
                          >
                            {t("User Profile.Endorsed")}
                          </button>
                        ) : (
                          <button
                            className="button followStyle"
                            onClick={() => {
                              setShowEndorseModal(!showEndorseModal);
                              setSkillId(item.usrSkllId);
                            }}
                          >
                            {t("User Profile.Endorse")}
                          </button>
                        )}
                      </div>
                    )}
                    </div>
                    )}
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}

      {visibleSkills?.length > 2 ? (
        <div className="empty-container d-flex justify-content-center align-items-center mb-0">
          <button>
            <span
              className="d-flex justify-content-center align-items-center skills-more-cont"
              onClick={() => {
                setShowMoreSkills(!showMoreSkills);
              }}
            >
              {/* <Link to={`/User/${uid}/Skills`} className="me-1"> */}
              {t("User Profile.Show all")} {visibleSkills?.length} {t("User Profile.Skills")}
              {/* </Link> */}
              <ArrowForwardSharpIcon className="material-symbols-sharp" />
            </span>
          </button>
        </div>
      ) : (
        ""
      )}

      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveSkillClose();
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => removeSkills()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showMoreSkills && (
        <div
          className="modal fade show postAdd modal-md"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-2">{t("User Profile.All Skills")}</h6>
                  <div>
                    {uid === userUid ? (
                      <AddSharpIcon
                        className="material-symbols-sharp pointer f-24 "
                        onClick={handleOpenAddSkill}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShowMoreSkills(false);
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <Skills
                  userData={userData}
                  showUndoEndorseModal={showUndoEndorseModal}
                  setShowUndoEndorseModal={setShowUndoEndorseModal}
                  setShowEndorseModal={setShowEndorseModal}
                  showEndorseModal={showEndorseModal}
                  setSkillId={setSkillId}
                  skillId={skillId}
                  getUserProfile={getUserProfile}
                  setShowMoreSkills={setShowMoreSkills}
                  showMoreSkills={showMoreSkills}
                  skillList={visibleSkills}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {showExperienceAchievementDelete && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>
                  {" "}
                  {t("User Profile.Are You Sure You want to Delete?")}
                </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleExperienceAchievementClose();
                  }}
                />
              </div>

              <div className="mt-2 text-center">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => DeleteExperienceAchivement()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showExperienceRoleDelete && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleExperienceRoleClose();
                  }}
                />
              </div>

              <div className="mt-2 text-center">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => DeleteExperienceRole()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEndorseModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6> {t("User Profile.FeedBack")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleClose();
                  }}
                />
              </div>

              <div>
                <div className="lableStyle pt-3">
                  <textarea
                    id="address"
                    name="about"
                    rows="4"
                    cols="55"
                    className="border w-100"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="mainBtn1 "
                  onClick={EndorseData}
                >
                  {t("User Profile.Endorse")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showUndoEndorseModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6> {t("User Profile.Undo Endorse")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleUndoEndorse();
                  }}
                />
              </div>

              <div>
                <div className="lableStyle">
                  <textarea
                    id="address"
                    name="about"
                    rows="4"
                    cols="55"
                    className="border"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  ></textarea>
                </div>
              </div>

              <div className="col-md-12 text-end mt-4">
                <button
                  type="button"
                  className="mainBtn1"
                  onClick={UndoEndorseData}
                >
                  {t("User Profile.Undo Endorse")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {showEducationDelete && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveEducationClose();
                  }}
                />
              </div>

              <div className="mt-2 text-center">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => removeEducation()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AddSkill
        show={showAddSkill}
        handleClose={handleCloseAddSkill}
        getUserProfile={getUserProfile}
      />

      <ProfileEducation
        showUSEREducation={showUSEREducation}
        handleCloseUSEREducation={handleCloseUSEREducation}
        // getUserUser={getUserUser}
        userUId={userUid}
        getUserProfile={getUserProfile}
        userData={userData}
      />
      <ProfileEducationUpdate
        showEducationUpdate={showEducationUpdate}
        setShowEducationUpdate={setShowEducationUpdate}
        handleUpdateEducationClose={handleUpdateEducationClose}
        educationData={educationData}
        // getUserUser={getUserUser}
        userUId={userUid}
        getUserProfile={getUserProfile}
        userData={userData}

      />
      <ProfileExperience
        showUserExperience={showUserExperience}
        handleCloseUserExperience={handleCloseUserExperience}
        userUId={userUid}
        getUserProfile={getUserProfile}
        userData={userData}
      />
      {/* <ProfileAchiementExperience
        showAchievementUserExperience={showAchievementUserExperience}
        handleAchievementCloseUserExperience={handleAchievementCloseUserExperience}
        userUId={userUid}
        getUserProfile={getUserProfile}
      /> */}
      <ProfileExperienceUpdate
        showExperienceUpdate={showExperienceUpdate}
        handleUpdateExperienceClose={handleUpdateExperienceClose}
        userUId={userUid}
        getUserProfile={getUserProfile}
        ExperienceData={ExperienceData}
      />

      <ProfileCertification
        showUserCertification={showUserCertification}
        handleCloseUserCertification={handleCloseUserCertification}
        userUId={userUid}
        getUserProfile={getUserProfile}
        userData={userData}
      />
      <ProfileCertificateUpdate
        showCertificateUpdate={showCertificateUpdate}
        handleUpdateCertificateClose={handleUpdateCertificateClose}
        userUId={userUid}
        getUserProfile={getUserProfile}
        certificateData={certificateData}
      />

      {showCertificateDelete && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveCertificateClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => removeCertificate()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ProfileAward
        showUserAward={showUserAward}
        handleCloseUserAward={handleCloseUserAward}
        userUId={userUid}
        getUserProfile={getUserProfile}
        userData={userData}
      />
      <ProfileAwardUpdate
        showAwardUpdate={showAwardUpdate}
        handleUpdateAwardClose={handleUpdateAwardClose}
        userUId={userUid}
        showAwardData={showAwardData}
        getUserProfile={getUserProfile}
      />
      <UpdateSkills
        showSkills={showSkills}
        handleUpdateSkillClose={handleUpdateSkillClose}
        userUId={userUid}
        getUserProfile={getUserProfile}
        skillsData={skillsData}
      />

      {/* //  *******************************    EXPERIENCE ACHIEVEMENT COMPONENTS ************************************************ */}
      <AddExperienceAchivement
        showExperienceAchivement={showExperienceAchivement}
        handleCloseExperienceAchivement={handleCloseExperienceAchivement}
        ExperienceData={ExperienceData}
        getUserProfile={getUserProfile}
      />
      <AddExperienceRole
        showExperienceRole={showExperienceRole}
        handleCloseExperienceRole={handleCloseExperienceRole}
        ExperienceData={ExperienceData}
        getUserProfile={getUserProfile}
      />

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {basicInfoModal && (
        <ProfileBasicInfoModal
          onClose={() => setBasicInfoModal(false)}
          getUserProfile={getUserProfile}
          initialProfileInfo={userData?.profileInfo}
        />
      )}

      {dob && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around overflow-visible">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6> {t("User Profile.DOB")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-0 pointer"
                  onClick={() => {
                    handledob();
                  }}
                />
              </div>
              <div className="d-flex modalBorder pb-2">
                <div className="col-md-12 mt-2 px-2 mb-2 userInput d-flex align-items-baseline flex-column">
                  {/* <h5>DOB</h5> */}
                  <div className="dateofbirth w-100">
                    <Flatpickr
                      className="form-control"
                      value={startDate}
                      onChange={(date) => setStartDate(date[0])}
                      id="dob"
                      placeholder={t("Common.SelectDate")}
                      options={{
                        maxDate: "today", // Disables future dates
                        onReady: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Call the function to stop scroll on year
                        },
                        onOpen: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Also prevent scroll when the picker opens
                        },
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="mainBtn1 me-2"
                  onClick={DobUpload}
                >
                  {t("User Profile.Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {genderModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Gender")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleGenderModal();
                  }}
                />
              </div>
              <div className="d-flex modalBorder pb-2 d-flex justify-content-center p-2">
                <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column align-items-center">
                  {/* <h4 htmlFor="about">Gender</h4> */}
                  <div className="col-md-12">
                    {/* <label htmlFor="about">Gender</label> */}
                    <ReactSelect className="NewGenderAdd"
                      defaultValue={genderOptions.find(
                        (option) => option.value === genderValue
                      )}
                      options={genderOptions}
                      onChange={selectGender}
                      loadOptions={selectGender}
                      placeholder={t("Newsfeed.Select Gender")}
                      styles={customStyles}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="mainBtn1 me-4"
                  onClick={GenderUpload}
                >
                  {t("User Profile.Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {aboutModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.About")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-0 pointer"
                  onClick={() => {
                    handleAboutModal();
                  }}
                />
              </div>

              <div className="d-flex modalBorder pb-2 d-flex justify-content-center p-2">
                <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column align-items-center">
                  <div className="col-md-12 mt-2 about-textArea">
                    <textarea
                      id="address"
                      name="about"
                      rows="4"
                      cols="55"
                      value={aboutContent}
                      onChange={(e) => {
                        setAboutContent(e.target.value);
                        setLength(e.target?.value.length);
                      }}
                      maxLength={500}
                    ></textarea>
                    <p className="info ">{aboutContent?.length && length}/500</p>
                  </div>
                </div>
              </div>
              <p className="p-2 text-danger f-14">
                {t("User Profile.About content should be less than 500 words")}
              </p>
              <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end px-2">
                <button
                  type="button"
                  className="mainBtn1 me-0"
                  onClick={AboutUpload}
                >
                  {t("User Profile.Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {websiteModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Company Profile.Website")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-0 pointer"
                  onClick={handlewebsiteModal}
                />
              </div>
              <div className="d-flex modalBorder pb-4 justify-content-center p-2">
                <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column align-items-center">
                  <div className="col-md-12 mt-2 web-input">
                    <div className="input-group input-group-alt">
                      <div className="input-group-prepend">
                        <span className="input-group-text">http://</span>
                      </div>
                      <input
                        type="text"
                        className="form-control pb-0 px-2"
                        id="pi3"
                        placeholder={t("Common.ExampleCom")}
                        value={websitecontent}
                        onChange={(e) => validateWebsite(e.target.value)}
                      />
                    </div>
                    {error && (
                      <div
                        style={{
                          color: "red",
                          marginTop: "5px",
                          fontSize: "12px",
                        }}
                      >
                        {error}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end px-2">
                <button
                  type="button"
                  className="mainBtn1 me-0"
                  onClick={handleSubmit}
                  disabled={!!error || !websitecontent.trim()}
                >
                  {t("User Profile.Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>

      )}

      {languageModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.City")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handlelanguageModal();
                  }}
                />
              </div>
              <div className="d-flex modalBorder pb-2 d-flex justify-content-center p-2">
                <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column align-items-center">
                  <div className="col-md-12 mt-2">
                  <label htmlFor="about">{t("User Profile.Country")}<span className="text-danger ms-2">*</span></label>
                    <Select
                      value={countryData.find(
                        (option) => option.value === countryId
                      )}
                      isClearable
                      options={countryData}
                      onChange={(selectedOption) => 
                        setCountryId(selectedOption ? selectedOption.value : "")}
                      placeholder={t("SearchJob.Select Country")}
                      onInputChange={(inputValue) => {
                        setCountrySearch(inputValue);
                      }}
                      styles={customStyles}
                    />
                  </div>
                <div className="col-md-12 mt-2">
                <label htmlFor="about">{t("User Profile.City")}<span className="text-danger ms-2">*</span></label>

                    <Select
                      // defaultValue={cityId}
                      value={cityData.find((option) => option.value === cityId)}
                      onChange={(selectedOption) =>
                        setCityId(selectedOption ? selectedOption.value : "")
                      }
                      options={cityData}
                      noOptionsMessage={() => t("modals.Search and Select City")}
                      placeholder={"Select City"}
                      onInputChange={(inputValue) => {
                        setCitySearch(inputValue);
                      }}
                      styles={customStyles}
                      isClearable
                    />

                  </div>
                </div>
              </div>

              <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="mainBtn1 me-4"
                  onClick={languageUpload}
                >
                  {t("User Profile.Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCancelRequestModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Cancel Request?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    cancelRequestClose();
                  }}
                />
              </div>

              <div className="text-center mt-3 mb-3 px-3 d-flex justify-content-center">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => CancelRequest()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <EditExperienceAchivement
        handleCloseEditExperienceAchivement={
          handleCloseEditExperienceAchivement
        }
        showEditExperienceAchivement={showEditExperienceAchivement}
        experienceAchivementData={experienceAchivementData}
        ExperienceData={ExperienceData}
        getUserProfile={getUserProfile}
      />
      <EditExperienceRole
        handleCloseEditExperienceRole={handleCloseEditExperienceRole}
        showEditExperienceRole={showEditExperienceRole}
        experienceRoleData={experienceRoleData}
        ExperienceData={ExperienceData}
        getUserProfile={getUserProfile}
      />
      <EndorseModal
        handleCloseModal={handleCloseModal}
        showModal={showModal}
        skillId={skillId}
      />
      <OfferAJobs
        userData={userData}
        openModal={openJobOfferModal}
        closeModal={() => {
          console.log("close");
          setOpenJobOfferModal(false);
        }}
        userUid={uid}
      />
      {showAwardDelete && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveAwardClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => removeAward()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showExperienceDelete && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveExperienceClose();
                  }}
                />
              </div>

              <div className="mt-2 text-center">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => removeExperience()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

       {followModal && <ModalForGuest closeModalData={closeModalData} />}

    </>
  );
};

export default About;
